import { useEffect, useState } from "react";
import Layout from "../../layouts/Layout";
import EmailVerification from "../../Components/AccountSetup/EmailVerification";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Welcome from "../../Components/AccountSetup/Welcome";
import Interests from "../../Components/AccountSetup/Interests";
import Preferences from "../../Components/AccountSetup/Preferences";
import FollowCreator from "../../Components/AccountSetup/FollowCreator";

const AccountSetup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState(location?.state?.followerReturn ? 4 : 0);
  const [progress, setProgress] = useState(
    location?.state?.followerReturn ? 100 : 10
  );
  const { userData } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    user: {
      id: userData?.id,
      firstName: userData?.firstName || "",
      lastName: userData?.lastName || "",
      phone: userData?.phone || "",
      bankName: userData?.bankName || "",
      iban: userData?.iban || "",
      youtube: userData?.youtube || "",
      instagram: userData?.instagram || "",
      tiktok: userData?.tiktokURL || "",
      twitter: userData?.twitterURL || "",
      receivePromos: userData?.receivePromos || false,
      interests: {
        jiuJitsu: false,
        boxing: false,
        muaythai: false,
        wrestling: false,
        kickboxing: false,
        mma: false,
        strength: false,
        mental: false,
        fighter: false,
      },
      joiningReason: {
        tutorials: false,
        professionalAccess: false,
        replays: false,
        behindTheScenes: false,
        training: false,
      },
      preferences: {
        ppvContent: false,
        subscriptionContent: false,
        freeContent: false,
      },
    },
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        [field]: value,
      },
    }));
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setFormData((prev) => {
      // If it's the "receivePromos" checkbox, update only `user.receivePromos`
      if (name === "receivePromos") {
        return {
          ...prev,
          user: {
            ...prev.user,
            receivePromos: checked,
          },
        };
      }

      // Default handling for other categories
      let category = null;
      if (prev.user.interests.hasOwnProperty(name)) {
        category = "interests";
      } else if (prev.user.joiningReason.hasOwnProperty(name)) {
        category = "joiningReason";
      } else if (prev.user.preferences.hasOwnProperty(name)) {
        category = "preferences";
      }

      return category
        ? {
            ...prev,
            user: {
              ...prev.user,
              [category]: {
                ...prev.user[category],
                [name]: checked,
              },
            },
          }
        : prev;
    });
  };

  const saveUserData = () => {
    try {
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (userData && userData.emailVerified && step === 0) {
      navigate("/dashboard");
    }
  }, [userData, step]);

  useEffect(() => {
    if (step === 5) {
      saveUserData();
    }
  }, [step]);

  return (
    <>
      {step === 0 ? (
        <EmailVerification setProgress={setProgress} setStep={setStep} />
      ) : step === 1 ? (
        <Welcome
          setStep={setStep}
          progress={progress}
          setProgress={setProgress}
          formData={formData}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
        />
      ) : step === 2 ? (
        <Interests
          setStep={setStep}
          progress={progress}
          setProgress={setProgress}
          formData={formData}
          setFormData={setFormData}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
        />
      ) : step === 3 ? (
        <Preferences
          setStep={setStep}
          progress={progress}
          setProgress={setProgress}
          formData={formData}
          setFormData={setFormData}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
        />
      ) : step === 4 ? (
        <FollowCreator
          setStep={setStep}
          progress={progress}
          setProgress={setProgress}
          formData={formData}
          handleCheckboxChange={handleCheckboxChange}
          handleInputChange={handleInputChange}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AccountSetup;
